import { useQuery } from 'react-query'
import { logFactory } from 'utils'
import { NoteServiceNoteType, RelatedEntityType, useNoteService } from '../services'

const hookName = 'useLatestFinancialNote'
const log = logFactory(hookName)

interface UseLatestFinancialNoteParams {
  opportunitySalesforceId?: string
}

const useLatestFinancialNote = ({ opportunitySalesforceId }: UseLatestFinancialNoteParams) => {
  const { getNote } = useNoteService()

  const query = {
    limit: 1,
    opportunitySalesforceId,
    relatedEntityType: RelatedEntityType.OPPORTUNITY,
    type: NoteServiceNoteType.FINANCIAL,
  }

  const doQuery = async () => {
    log('💰 Fetching financial note...', { opportunitySalesforceId })
    const response = await getNote(query)

    log('💰 Found %d financial notes', response?.data?.length ?? 0)
    return response?.data?.[0]?.content ?? null
  }

  return useQuery([hookName, query], doQuery, {
    enabled: Boolean(opportunitySalesforceId),
  })
}

export { useLatestFinancialNote }
